export async function sendAccountActivityNotification(
  accessToken,
  eventType
) {
  if (!accessToken || !eventType) {
    return false;
  }

  try {
    const response = await fetch(
      '/.netlify/functions/account-activity-notification',
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventType,
        }),
      }
    );

    if (!response.ok) {
      let result = {};

      try {
        result = await response.json();
      } catch {
        result = {};
      }

      console.warn(
        'Account notification was not sent:',
        result?.error || response.statusText
      );

      return false;
    }

    return true;
  } catch (error) {
    console.warn(
      'Account notification was not sent:',
      error
    );

    return false;
  }
}
